export const lightPrimary = {
  contrast: '#ffffff',
  dark: '#047857',
  light: '#34D399',
  main: '#059669'
};

export const lightSecondary = {
  contrast: '#ffffff',
  dark: '#0F766E',
  light: '#5EEAD4',
  main: '#0D9488'
};

export const lightError = {
  contrast: '#ffffff',
  dark: '#a53531',
  light: '#ef6f6b',
  main: '#ec4c47'
};

export const lightWarning = {
  contrast: '#ffffff',
  dark: '#975b1e',
  light: '#e09b55',
  main: '#d9822b'
};

export const lightInfo = {
  contrast: '#ffffff',
  dark: '#0b4e8d',
  light: '#3f8cd4',
  main: '#1070CA'
};

export const lightSuccess = {
  contrast: '#ffffff',
  dark: '#1b774d',
  light: '#52bb8b',
  main: '#27AB6E'
};

export const lightBackground = {
  default: '#F8FAFC',
  paper: '#ffffff'
};

export const lightText = {
  primary: '#0F172A',
  // Darkened from the old greyish slate so secondary text (captions, table
  // headers, subtitles) reads as normal dark text across all pages.
  secondary: '#0F172A'
};

export const lightNeutral = {
  100: '#f1f5f9',
  200: '#e2e8f0',
  300: '#cbd5e1',
  400: '#94a3b8',
  500: '#64748b',
  600: '#475569',
  700: '#334155',
  800: '#1e293b',
  900: '#0f172a'
};

export const darkPrimary = {
  contrast: '#ffffff',
  dark: '#059669',
  light: '#6EE7B7',
  main: '#34D399'
};

export const darkSecondary = {
  contrast: '#ffffff',
  dark: '#0D9488',
  light: '#5EEAD4',
  main: '#2DD4BF'
};

export const darkError = {
  contrast: '#ffffff',
  dark: '#85372b',
  light: '#eb6d57',
  main: '#e6492d'
};

export const darkWarning = {
  contrast: '#ffffff',
  dark: '#8D682d',
  light: '#f7bb57',
  main: '#f6ab2e'
};

export const darkInfo = {
  contrast: '#ffffff',
  dark: '#1D4580',
  light: '#4483df',
  main: '#1664d8'
};

export const darkSuccess = {
  contrast: '#ffffff',
  dark: '#2F6b39',
  light: '#5fc16d',
  main: '#38b249'
};

export const darkBackground = {
  default: '#0C1017',
  paper: '#0C1017'
};

export const darkText = {
  primary: '#e2e8f0',
  secondary: '#94a3b8'
};

export const darkNeutral = {
  100: '#1e293b',
  200: '#334155',
  300: '#475569',
  400: '#64748b',
  500: '#94a3b8',
  600: '#cbd5e1',
  700: '#e2e8f0',
  800: '#f1f5f9',
  900: '#f8fafc'
};
